import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import PluginCards from 'components/Quick_Installation/Live_Video/PluginCards';
import AVCards from 'components/Quick_Installation/Live_Video/AVCards';
import NavButtons from 'components/Quick_Installation/NavButtons';
import ForumBox from 'components/Quick_Installation/Live_Video/ForumBox';
import TimeLine from 'components/Products/CommentList/HomekitAlexaList';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  PluginCards,
  AVCards,
  NavButtons,
  ForumBox,
  TimeLine,
  BreadCrumbs,
  SEOHelmet,
  React
};